import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Checkbox,
  FormControlLabel,
  Autocomplete,
  LinearProgress,
  Typography,
  InputAdornment,
  Switch,
  Card,
  CardMedia,
  CardContent,
  Divider,
  IconButton,
  Grid,
  Paper,
  Stack,
  Stepper,
  Step,
  StepLabel,
  Tooltip,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import {
  ArrowBack,
  ArrowForward,
  Delete as DeleteIcon,
  AutoFixHigh as AutoFixHighIcon,
} from "@mui/icons-material";
import { DesktopDatePicker, TimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import axios from "axios";
import ImageUploader from "./ImageUploader";
import buildHtmlContent from "./HtmlContentBuilder";
import CategoryIcon from "@mui/icons-material/Category";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import InfoIcon from "@mui/icons-material/Info";
import ImageIcon from "@mui/icons-material/Image";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ScheduleIcon from "@mui/icons-material/Schedule";
import DetailsIcon from "@mui/icons-material/Details";
import StorageIcon from "@mui/icons-material/Storage";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

// Add wave distortion and background wave animation for rephrase effect (fancy colorful)
const style = document.createElement("style");
style.innerHTML = `
@keyframes waveDistort {
  0% { background-position: 0% 50%; transform: skewX(0deg); }
  25% { background-position: 50% 50%; transform: skewX(5deg) scale(1.01); }
  50% { background-position: 100% 50%; transform: skewX(-5deg) scale(0.99); }
  75% { background-position: 50% 50%; transform: skewX(3deg) scale(1.02); }
  100% { background-position: 0% 50%; transform: skewX(0deg) scale(1); }
}
@keyframes waveBackground {
  0% { background-position: 0% 50%; opacity: 0.8; }
  50% { background-position: 100% 50%; opacity: 1; }
  100% { background-position: 0% 50%; opacity: 0.8; }
}
.wave-effect .MuiOutlinedInput-root {
  background: linear-gradient(270deg, #7c3aed, #06b6d4, #ec4899, #f59e0b);
  background-size: 400% 400%;
  animation: waveBackground 1.5s ease;
  border-radius: 12px;
  transition: background 0.5s, opacity 0.5s;
}
.wave-effect .MuiInputBase-input {
  animation: waveDistort 1.2s ease;
  background: linear-gradient(270deg, #7c3aed, #06b6d4, #ec4899, #f59e0b);
  background-size: 800% 800%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}
`;
if (
  typeof document !== "undefined" &&
  !document.getElementById("wave-effect-style")
) {
  style.id = "wave-effect-style";
  document.head.appendChild(style);
}

// Map for [range_shortcode val] expected by the site
// Nou -> 1, Excelent -> 2, Foarte Bun(ă) -> 3, Bun(ă) -> 4, Rezonabil -> 5
const conditionOptions = {
  Nou: 1,
  Excelent: 2,
  "Foarte Buna": 3,
  "Foarte Bună": 3,
  Buna: 4,
  Bună: 4,
  Rezonabil: 5,
};

const CreateProductWoo = ({ wooCategories, productData }) => {
  const [localWooCategories, setLocalWooCategories] = useState([]); // Definim starea locală pentru categoriile preluate
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const [salePrice, setSalePrice] = useState("");
  const [msrpPrice, setMsrpPrice] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("draft");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [productType, setProductType] = useState("");
  const [brand, setBrand] = useState("");
  const [condition, setCondition] = useState("");
  const [customDescription, setCustomDescription] = useState("");
  const [isSaleScheduled, setIsSaleScheduled] = useState(false);
  const [isProductScheduled, setIsProductScheduled] = useState(false);
  const [scheduledDate, setScheduledDate] = useState(null);
  const [scheduledTime, setScheduledTime] = useState(null);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);
  const [progress, setProgress] = useState(0);
  const [nextProductId, setNextProductId] = useState(null);
  const [sku, setSku] = useState("");
  const [exteriorColor, setExteriorColor] = useState("");
  const [interiorColor, setInteriorColor] = useState("");
  const [exteriorMaterial, setExteriorMaterial] = useState("");
  const [interiorMaterial, setInteriorMaterial] = useState("");
  const [includedItems, setIncludedItems] = useState([]);
  const [hardwareColor, setHardwareColor] = useState("");
  const [designerId, setDesignerId] = useState("");
  const [entrupyId, setEntrupyId] = useState("");
  const [location, setLocation] = useState("");
  const [length, setLength] = useState("");
  const [height, setHeight] = useState("");
  const [depth, setDepth] = useState("");
  const [detailedDescription, setDetailedDescription] = useState("");
  const [sortlyId, setSortlyId] = useState("");
  const [layawayOption, setLayawayOption] = useState("");
  const [isLayaway, setIsLayaway] = useState(false);
  const [pentru, setPentru] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState("");
  const [name, setName] = useState("");
  const [categorie, setCategorie] = useState("");
  const [stare, setStare] = useState("");
  const [descriereSpecifica, setDescriereSpecifica] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  // UI Enhancements: density, validation errors, active section for tips
  const [compact, setCompact] = useState(true);
  const [errors, setErrors] = useState({});
  const [activeSection, setActiveSection] = useState("section-info");
  const [touched, setTouched] = useState({});
  const [rephraseLoading, setRephraseLoading] = useState(false);
  const [waveEffect, setWaveEffect] = useState(false);
  const [rephraseDetailedLoading, setRephraseDetailedLoading] = useState(false);
  const [waveEffectDetailed, setWaveEffectDetailed] = useState(false);
  // Edit mode state
  const [originalProduct, setOriginalProduct] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const setFieldTouched = (name) =>
    setTouched((prev) => ({ ...prev, [name]: true }));

  const setErrorFor = (field, message) =>
    setErrors((prev) => ({ ...prev, [field]: message }));
  // --- Edit mode helpers ---
  const unionUnique = (arrA = [], arrB = []) =>
    Array.from(
      new Set(
        [...(arrA || []), ...(arrB || [])].filter(
          (v) => v !== null && v !== undefined && String(v).trim() !== ""
        )
      )
    );
  const toWooCategories = (cats) => (cats || []).map((c) => ({ id: c.id }));
  const findAttr = (attrs = [], keyMatch) =>
    attrs.find(
      (a) =>
        (a.slug || "").toLowerCase() === keyMatch ||
        (a.name || "").toLowerCase() === keyMatch
    );

  const productTypes = [
    "BEST DEAL",
    "MUST HAVE",
    "VINTAGE",
    "HARD TO FIND",
    "LUXURA EXCLUSIVE",
    "TRENDING",
    "NEW COLLECTION",
  ];
  const brands = [
    "HERMÈS",
    "DIOR",
    "CHANEL",
    "GUCCI",
    "ADIDAS",
    "ALEXANDER MCQUEEN",
    "AQUAZZURA",
    "BALENCIAGA",
    "BALMAIN",
    "BOTTEGA VENETA",
    "BOUCHERON",
    "BRIONI",
    "BURBERRY",
    "BUSCEMI",
    "CARTIER",
    "CASADEI",
    "CHLOE",
    "CHOPARD",
    "CHRISTIAN LOUBOUTIN",
    "DAVIDOFF BY S.T.DUPONT",
    "ELISABETTA FRANCHI",
    "ERMANNO SCERVINO",
    "FENDI",
    "GIUSEPPE ZANOTTI",
    "GIVENCHY",
    "HAWES&Curtis",
    "JACQUEMUS",
    "JF ANDERSON",
    "JUST CAVALLI",
    "JW ANDERSON",
    "LE SILLA",
    "LOEWE",
    "LOUIS VUITTON",
    "MANOLO BLAHNIK",
    "MAX MARA",
    "MCM",
    "MEDAGLIANI",
    "MITILIANE COUTURE",
    "MIU MIU",
    "MONCLER",
    "MOSCHINO",
    "POMELLATO",
    "PRADA",
    "S.T.DUPONT",
    "SAINT LAURENT",
    "SERGIO ROSSI",
    "SEVDA",
    "TAG HEUER",
    "TISSOT",
    "TOM FORD",
    "VALENTINO",
    "VERSACE",
    "VLTN",
    "YVES SAINT LAURENT",
    "ZIMMERMANN",
    "ADIDAS X GUCCI",
    "ALAIA",
    "ALEXANDER WANG",
    "AMINA MUADDI",
    "AREA",
    "BALENCIAGA X ADIDAS",
    "BALLY",
    "BALLY BREANNE",
    "BALMAIN X BARBIE",
    "BERLUTI",
    "BREITLING",
    "BROWNS",
    "BRUNELLO CUCINELLI",
    "BURBERRY X VIVIENNE WESTWOOD",
    "BVLGARI",
    "CARL F. BUCHERER",
    "CELINE",
    "CULT GAIA",
    "DIAMONDS MINE",
    "DIOR X SACAI",
    "DOLCE & GABBANA",
    "DSQUARED2",
    "EMILIO PUCCI",
    "EMPRESA",
    "ERMENEGILDO ZEGNA",
    "ETRO",
    "FAUSTO PUGLISI",
    "FREYWILLE",
    "GIANVITO ROSSI",
    "GIORGIO VISCONTI",
    "GUCCI X ADIDAS",
    "GUCCI X BALENCIAGA",
    "GUCCI X BANANYA",
    "GUCCI X DISNEY",
    "GUCCI X THE NORTH FACE",
    "GUESS",
    "HULCHI BELLUNI",
    "INEL",
    "ISABEL MARANT",
    "JIMMY CHOO",
    "LORO PIANA",
    "LOUIS VUITTON X JEFF KOONS",
    "MACH & MACH",
    "MARINE SERRE",
    "MARNI",
    "MICHAEL KORS",
    "MONSE",
    "MORE JOY",
    "MULBERRY",
    "NIKE AF1 X SWAROVSKI",
    "OFF-WHITE",
    "OMEGA",
    "PATRICIA AVENDANO",
    "PHILIPP PLEIN",
    "PINKO",
    "POLO RALPH LAUREN",
    "RED VALENTINO",
    "ROBERTO CAVALLI",
    "ROLAND MOURET",
    "ROLEX",
    "ROSANTICA",
    "RUSLAN BAGINSKIY",
    "SALVATORE FERRAGAMO",
    "SOPHIA WEBSTER",
    "STELLA MCCARTNEY",
    "TAG HEUER",
    "TIFFANY",
    "TIFFANY & CO.",
    "TIRISI",
    "VALEXTRA",
    "VALENTINO",
    "VAN CLEEF & ARPELS",
    "WOOLRICH",
  ];

  const categoryPrefixes = {
    Accesorii: "ACLEB00",
    Incaltaminte: "SSLEB00",
    Bijuterii: "JLLEB00",
    "Genti de desgineri pre-owned": "HBLEB00",
    Imbracaminte: "CLLEB00",
    // Adaugă aici alte categorii și prefixele lor
  };

  const validateForm = () => {
    const e = {};
    if (!productType) e.productType = "Selectează un badge.";
    if (!brand) e.brand = "Selectează brandul.";
    if (!title || !title.trim()) e.title = "Completează modelul.";
    if (!selectedCategories || selectedCategories.length === 0)
      e.categories = "Alege cel puțin o categorie.";
    const p = parseFloat(price);
    if (!Number.isFinite(p) || p <= 0) e.price = "Introdu un preț valid (> 0).";
    if (!condition) e.condition = "Selectează condiția.";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onBlurValidate = (field) => {
    switch (field) {
      case "productType":
        setFieldTouched("productType");
        setErrorFor(
          "productType",
          productType ? undefined : "Selectează un badge."
        );
        break;
      case "brand":
        setFieldTouched("brand");
        setErrorFor("brand", brand ? undefined : "Selectează brandul.");
        break;
      case "title":
        setFieldTouched("title");
        setErrorFor(
          "title",
          title && title.trim() ? undefined : "Completează modelul."
        );
        break;
      case "categories":
        setFieldTouched("categories");
        setErrorFor(
          "categories",
          selectedCategories && selectedCategories.length
            ? undefined
            : "Alege cel puțin o categorie."
        );
        break;
      case "price":
        setFieldTouched("price");
        const p = parseFloat(price);
        setErrorFor(
          "price",
          Number.isFinite(p) && p > 0
            ? undefined
            : "Introdu un preț valid (> 0)."
        );
        break;
      case "condition":
        setFieldTouched("condition");
        setErrorFor(
          "condition",
          condition ? undefined : "Selectează condiția."
        );
        break;
      default:
        break;
    }
  };

  // Helper: accent-insensitive lowercase
  const normalize = (s) =>
    (s || "")
      .toString()
      .toLowerCase()
      .replace(
        /[ăâîșşțţ]/g,
        (m) =>
          ({ ă: "a", â: "a", î: "i", ș: "s", ş: "s", ț: "t", ţ: "t" })[m] || m
      );

  const isFootwearSelected = React.useMemo(
    () =>
      (selectedCategories || []).some((c) =>
        normalize(c.name).includes("incaltaminte")
      ),
    [selectedCategories]
  );

  const consumerKey = "ck_a941824be557253d3765a1f6242e6d6a590da999";
  const consumerSecret = "cs_6b0d98e4c442e707be9888cafff1fac17cdbf259";

  const username = "ciprian.bucurei@gmail.com";
  const password = "dgUp Z1Cv Rqxg pjx2 s3TF ZjOQ";

  useEffect(() => {
    // Verificăm dacă există productData pentru a popula câmpurile
    if (productData) {
      console.log("Received productData:", productData);

      // --- Enhanced parse HTML name for badge, brand, model, and ensure dropdowns are prepopulated ---
      if (productData.name) {
        try {
          const wrapper = document.createElement("div");
          wrapper.innerHTML = productData.name;

          const spanText = wrapper.querySelector("span")?.textContent?.trim();
          const strongText = wrapper
            .querySelector("strong")
            ?.textContent?.trim();
          const divText = wrapper.querySelector("div")?.textContent?.trim();

          // For productType: add to productTypes if not present, then setProductType
          if (spanText) {
            if (!productTypes.includes(spanText)) {
              productTypes.push(spanText);
            }
            setProductType(spanText);
          }

          // For brand: normalize to uppercase and trim, add to brands if not present, then setBrand
          if (strongText) {
            const brandNormalized = strongText.toUpperCase().trim();
            if (!brands.includes(brandNormalized)) {
              brands.push(brandNormalized);
            }
            setBrand(brandNormalized);
          }

          // For model assignment, set only the cleaned div text (not the raw name)
          if (divText) {
            setTitle(divText);
          }
        } catch (e) {
          // ignore parse errors
        }
      }

      // Setăm prețul regular sau cel normal
      setPrice(
        productData.regular_price ||
          productData.regularPrice ||
          productData.price ||
          ""
      );

      // Setăm prețul redus (dacă există)
      setSalePrice(productData.sale_price || productData.salePrice || "");

      // Setăm SKU-ul produsului
      setSku(productData.sku || "");

      // Setăm descrierea produsului
      setDescription(productData.description || "");

      // Setăm categoriile produsului, mapând la formatul necesar
      setSelectedCategories(
        Array.isArray(productData.categories)
          ? productData.categories.map((category) => ({
              id: category.id,
              name: category.name,
              label: category.name,
            }))
          : []
      );

      // Setează alte câmpuri după caz (asigurându-te că valorile nu sunt undefined sau null)
      setExteriorColor(productData.externalColor || "");
      setInteriorColor(productData.interiorColor || "");
      setExteriorMaterial(productData.exteriorMaterial || "");
      setInteriorMaterial(productData.interiorMaterial || "");
      setCondition(productData.condition || "");
      setLength(productData.length || "");
      setHeight(productData.height || "");
      setDepth(productData.depth || "");
      setIncludedItems(productData.includedItems || []);
      setDesignerId(productData.designerId || "");
      setLocation(productData.location || "");
      setSortlyId(productData.sortlyId || "");
      setLayawayOption(productData.layawayOption || "");
      setIsLayaway(productData.isLayaway || false);

      // --- Enhanced edit mode support ---
      setOriginalProduct(productData);
      setIsEditMode(!!productData.id);
      // Prices and status (corrected logic)
      // Preț actual (Price) = productData.price
      setPrice(productData.price || "");

      // Preț promoțional (Sale Price) = productData.sale_price
      setSalePrice(productData.sale_price || "");

      // Preț regular (MSRP) = productData.msrp_price or from meta_data
      let msrp = "";
      if (productData.msrp_price) {
        msrp = productData.msrp_price;
      } else if (Array.isArray(productData.meta_data)) {
        const metaMsrp = productData.meta_data.find(
          (m) => m.key === "msrp_price"
        );
        if (metaMsrp?.value) msrp = metaMsrp.value;
      }
      setMsrpPrice(msrp || "");
      setStatus(productData.status || status);

      // Attributes mapping
      const attrs = Array.isArray(productData.attributes)
        ? productData.attributes
        : [];
      const getOptions = (slugOrName) =>
        findAttr(attrs, slugOrName)?.options || [];

      const brandAttr = getOptions("pa_designeri");
      if (brandAttr[0]) setBrand(brandAttr[0]);

      const condAttr = getOptions("pa_conditie");
      if (condAttr[0]) setCondition(condAttr[0]);

      const badgeAttr = getOptions("pa_badge");
      if (badgeAttr[0]) setProductType(badgeAttr[0]);

      const forAttr = getOptions("pa_pentru");
      if (forAttr[0]) setPentru(forAttr[0]);

      const colorAttr = getOptions("pa_color");
      if (colorAttr.length) {
        setExteriorColor(colorAttr[0] || exteriorColor);
        setInteriorColor(colorAttr[1] || interiorColor);
      }

      const designerAttr = getOptions("pa_designerid");
      if (designerAttr[0]) setDesignerId(designerAttr[0]);

      const insotitAttr = getOptions("pa_insotit");
      if (insotitAttr.length) setIncludedItems(insotitAttr);

      const marimeAttr = getOptions("pa_marime");
      if (marimeAttr[0]) setLength(String(marimeAttr[0]));

      // Categories (already set above)
      setSelectedCategories(
        Array.isArray(productData.categories)
          ? productData.categories.map((c) => ({
              id: c.id,
              name: c.name,
              label: c.name,
            }))
          : []
      );

      // Keep existing description as the base when editing
      setDetailedDescription(productData.description || detailedDescription);
    }
  }, [productData]);

  useEffect(() => {
    const fetchLastProductId = async () => {
      try {
        const response = await axios.get(
          "https://www.luxuraelite.ro/wp-json/wc/v3/products",
          {
            params: {
              per_page: 1,
              orderby: "id",
              order: "desc",
            },
            headers: {
              Authorization:
                "Basic " + btoa(`${consumerKey}:${consumerSecret}`),
            },
          }
        );
        const lastProductId = response.data[0]?.id || 0;
        setNextProductId(lastProductId + 1);
      } catch (error) {
        console.error("Error fetching last product ID:", error);
      }
    };

    fetchLastProductId();
  }, []);

  useEffect(() => {
    if (nextProductId && selectedCategories.length > 0) {
      const mainCategory = selectedCategories[0]?.name;
      const prefix = categoryPrefixes[mainCategory] || "UNKNOWN";
      setSku(`${prefix}${nextProductId}`);
    }
  }, [nextProductId, selectedCategories]);

  // Folosim localWooCategories pentru a stoca categoriile preluate din WooCommerce
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://www.luxuraelite.ro/wp-json/wc/v3/products/categories?per_page=100",
          {
            headers: {
              Authorization:
                "Basic " + btoa(`${consumerKey}:${consumerSecret}`),
            },
          }
        );
        const categories = response.data;
        const hierarchicalCategories = buildCategoryHierarchy(categories);
        console.log("Categorii ierarhizate:", hierarchicalCategories); // Add this
        setLocalWooCategories(hierarchicalCategories);
      } catch (error) {
        console.error("Error fetching WooCommerce categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const buildCategoryHierarchy = (categories) => {
    const categoryMap = {};
    const roots = [];

    // Creează un map al categoriilor
    categories.forEach((category) => {
      categoryMap[category.id] = { ...category, children: [] };
    });

    // Construiește ierarhia
    categories.forEach((category) => {
      if (category.parent === 0) {
        roots.push(categoryMap[category.id]);
      } else {
        const parentCategory = categoryMap[category.parent];
        if (parentCategory) {
          parentCategory.children.push(categoryMap[category.id]);
        }
      }
    });

    return roots;
  };

  const compressAndResizeImage = async (imageFile) => {
    try {
      console.log("Sending image for compression:", imageFile.name);
      const formData = new FormData();
      formData.append("image", imageFile);

      const response = await axios.post(
        "https://server-9p4hx.kinsta.app/api/masterdata/compress",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        }
      );

      const compressedImage = new File([response.data], imageFile.name, {
        type: imageFile.type,
      });
      console.log("Image compressed successfully:", compressedImage.name);
      return compressedImage;
    } catch (error) {
      console.error("Error compressing and resizing image:", error);
      alert("Failed to compress and resize image.");
      return null;
    }
  };

  const uploadImage = async (imageFile) => {
    const url = "https://www.luxuraelite.ro/wp-json/wp/v2/media";

    const formData = new FormData();
    formData.append("file", imageFile);

    const auth = btoa(`${username}:${password}`);

    try {
      console.log("Uploading image to WooCommerce:", imageFile.name);
      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Basic ${auth}`,
          "Content-Disposition": `attachment; filename=${imageFile.name}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          setProgress(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          );
        },
      });

      console.log("Image uploaded successfully:", response.data);
      return response.data.id;
    } catch (error) {
      console.error(
        "Error uploading image:",
        error.response ? error.response.data : error.message
      );
      alert("Failed to upload image.");
      return null;
    }
  };

  const handleImageChange = async (type, images) => {
    if (type === "profile") {
      const imageFile = images;
      const compressedImage = await compressAndResizeImage(imageFile);
      if (compressedImage) {
        setProfileImage({ file: imageFile });
        const imageId = await uploadImage(compressedImage);
        if (imageId) {
          setProfileImage({ file: imageFile, id: imageId });
        }
      }
    } else {
      const newGalleryImages = [];
      let currentImageIndex = galleryImages.length + 1;
      for (const imageFile of images) {
        const compressedImage = await compressAndResizeImage(imageFile);
        if (compressedImage) {
          setGalleryImages((prevImages) => [
            ...prevImages,
            { file: imageFile },
          ]);
          setUploadStatus(
            `Uploading image ${currentImageIndex} of ${images.length}`
          );
          currentImageIndex++;
          const imageId = await uploadImage(compressedImage);
          if (imageId) {
            newGalleryImages.push({ file: imageFile, id: imageId });
          }
        }
      }
      setGalleryImages([...galleryImages, ...newGalleryImages]);
      setUploadStatus("Done");
    }
  };

  const handleMoveImageLeft = (index) => {
    if (index > 0) {
      const newGalleryImages = [...galleryImages];
      const temp = newGalleryImages[index - 1];
      newGalleryImages[index - 1] = newGalleryImages[index];
      newGalleryImages[index] = temp;
      setGalleryImages(newGalleryImages);
    }
  };

  const handleMoveImageRight = (index) => {
    if (index < galleryImages.length - 1) {
      const newGalleryImages = [...galleryImages];
      const temp = newGalleryImages[index + 1];
      newGalleryImages[index + 1] = newGalleryImages[index];
      newGalleryImages[index] = temp;
      setGalleryImages(newGalleryImages);
    }
  };

  const deleteImageFromWoo = async (imageId) => {
    const auth = btoa(`${username}:${password}`);
    try {
      await axios.delete(
        `https://www.luxuraelite.ro/wp-json/wp/v2/media/${imageId}`,
        {
          headers: {
            Authorization: `Basic ${auth}`,
          },
        }
      );
      console.log(`Image ${imageId} deleted successfully.`);
    } catch (error) {
      console.error(
        "Error deleting image:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const handleDeleteImage = async (index) => {
    const imageToDelete = galleryImages[index];
    await deleteImageFromWoo(imageToDelete.id);
    const updatedImages = galleryImages.filter((_, i) => i !== index);
    setGalleryImages(updatedImages);
  };

  const handleCreateProduct = async () => {
    // Validate required fields visually and block submit if invalid
    if (!validateForm()) {
      const firstErrorSection = errors.price
        ? "section-pricing"
        : errors.productType ||
            errors.brand ||
            errors.title ||
            errors.categories
          ? "section-info"
          : errors.condition
            ? "section-attributes"
            : "section-info";
      const el = document.getElementById(firstErrorSection);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    const normalizedBrand = (brand || "").trim().toUpperCase();

    // --- Edit mode PATCH support ---
    if (isEditMode && originalProduct) {
      try {
        const updateData = {};

        // Only send fields that changed
        if (price && price !== originalProduct.regular_price)
          updateData.regular_price = price;
        if (salePrice && salePrice !== originalProduct.sale_price)
          updateData.sale_price = salePrice;
        if (status && status !== originalProduct.status)
          updateData.status = status;
        if (isSaleScheduled && (dateFrom || dateTo)) {
          updateData.date_on_sale_from = dateFrom
            ? dayjs(dateFrom).format("YYYY-MM-DD")
            : null;
          updateData.date_on_sale_to = dateTo
            ? dayjs(dateTo).format("YYYY-MM-DD")
            : null;
        }

        // Categories: union existing with selected (do not remove existing)
        if ((selectedCategories || []).length) {
          const existingCatIds = (originalProduct.categories || []).map(
            (c) => c.id
          );
          const selectedCatIds = (selectedCategories || []).map((c) => c.id);
          const catIds = unionUnique(existingCatIds, selectedCatIds).map(
            (id) => ({ id })
          );
          updateData.categories = catIds;
        }

        // Attributes: merge by slug, only add missing options, do not drop anything
        if (originalProduct.attributes) {
          const mergedAttrs = JSON.parse(
            JSON.stringify(originalProduct.attributes)
          );
          const upsert = (slug, name, toAdd) => {
            if (!toAdd || (Array.isArray(toAdd) && !toAdd.length)) return;
            const idx = mergedAttrs.findIndex(
              (a) =>
                (a.slug || "").toLowerCase() === slug ||
                (a.name || "").toLowerCase() === name.toLowerCase()
            );
            if (idx >= 0) {
              mergedAttrs[idx].options = unionUnique(
                mergedAttrs[idx].options,
                Array.isArray(toAdd) ? toAdd : [toAdd]
              );
            } else {
              mergedAttrs.push({
                name,
                slug,
                visible: true,
                variation: false,
                options: Array.isArray(toAdd) ? toAdd : [toAdd],
              });
            }
          };
          upsert("pa_conditie", "Condiție", condition ? [condition] : []);
          upsert(
            "pa_designeri",
            "Designeri",
            normalizedBrand ? [normalizedBrand] : []
          );
          upsert("pa_badge", "Badge", productType ? [productType] : []);
          upsert(
            "pa_color",
            "Culoare",
            unionUnique([exteriorColor], [interiorColor].filter(Boolean))
          );
          upsert("pa_designerid", "DesignerID", designerId ? [designerId] : []);
          upsert("pa_insotit", "Insotit", includedItems || []);
          if (isFootwearSelected && length)
            upsert("pa_marime", "Marime incaltaminte", [String(length)]);
          updateData.attributes = mergedAttrs;
        }

        // Description: if user added anything new (customDescription or detailedDescription changed),
        // append our new block after the original HTML instead of replacing it.
        let appendBlock = "";
        const hasNewSpecific =
          customDescription && customDescription.trim().length > 0;
        const hasNewDetailed =
          detailedDescription &&
          detailedDescription.trim().length > 0 &&
          detailedDescription !== (originalProduct.description || "");
        if (hasNewSpecific || hasNewDetailed) {
          const extra = buildHtmlContent({
            conditionValue: Number(conditionOptions[condition] || 0),
            conditionText: condition,
            customDescription: hasNewSpecific ? customDescription : "",
            detailedDescription: hasNewDetailed ? detailedDescription : "",
            brand: normalizedBrand,
            productType,
            title,
            exteriorColor,
            interiorColor,
            exteriorMaterial,
            interiorMaterial,
            hardwareColor,
            includedItems,
            designerId,
            entrupyId,
            location,
            sortlyId,
            length,
            height,
            depth,
            isFootwear: isFootwearSelected,
            layaway: isLayaway,
            layawayPlan: isLayaway ? layawayOption : null,
            layawayDetails: { fullPrice: price, salePrice, layawayOption },
            price,
            salePrice,
            msrpPrice,
            productInfo: {
              colorExt: exteriorColor,
              colorInt: interiorColor,
              materialExt: exteriorMaterial,
              materialInt: interiorMaterial,
              includes: includedItems,
              hardware: hardwareColor,
              designerId,
              entrupyId,
              location,
              dimensions: { length, height, depth },
            },
            richDescription: hasNewDetailed ? detailedDescription : "",
            specificDescription: hasNewSpecific ? customDescription : "",
            toggles: [],
            layawayTable: null,
          });
          appendBlock = `\n<!-- LUXURA-INTRANET APPEND START -->\n${extra}\n<!-- LUXURA-INTRANET APPEND END -->\n`;
          updateData.description =
            (originalProduct.description || "") + appendBlock;
        }

        // Meta data: keep existing meta and only add/override our SEO fields if present
        if (originalProduct.meta_data) {
          const meta = JSON.parse(JSON.stringify(originalProduct.meta_data));
          const upsertMeta = (key, value) => {
            if (value === undefined || value === null || value === "") return;
            const idx = meta.findIndex((m) => m.key === key);
            if (idx >= 0) meta[idx].value = value;
            else meta.push({ key, value });
          };
          const primaryCategoryName =
            selectedCategories && selectedCategories.length
              ? selectedCategories[0].name
              : "";
          const focusTitle =
            `${normalizedBrand ? normalizedBrand : ""} ${
              title ? title : ""
            }`.trim();
          const yoastDescription =
            `Descoperă ${normalizedBrand || ""} ${
              title || ""
            } pre-owned. Descoperă o selecție diversificată de stiluri de ${
              primaryCategoryName || "categorie"
            } ${normalizedBrand || ""}`
              .replace(/\s+/g, " ")
              .trim();
          upsertMeta("_yoast_wpseo_focuskw", focusTitle);
          upsertMeta("_yoast_wpseo_title", focusTitle);
          upsertMeta("_yoast_wpseo_metadesc", yoastDescription);
          upsertMeta("_yoast_wpseo_opengraph-title", focusTitle);
          upsertMeta("_yoast_wpseo_opengraph-description", yoastDescription);
          upsertMeta("_yoast_wpseo_twitter-title", focusTitle);
          upsertMeta("_yoast_wpseo_twitter-description", yoastDescription);
          updateData.meta_data = meta;
        }

        console.log("[edit-mode] Update payload:", updateData);

        const productResponse = await axios.put(
          `https://www.luxuraelite.ro/wp-json/wc/v3/products/${originalProduct.id}`,
          updateData,
          {
            headers: {
              Authorization:
                "Basic " + btoa(`${consumerKey}:${consumerSecret}`),
            },
          }
        );
        console.log("Product Updated:", productResponse.data);
        alert("Product updated successfully!");
        return;
      } catch (error) {
        console.error(
          "Error updating product:",
          error?.response?.data || error?.message
        );
        alert("Failed to update product.");
        return;
      }
    }

    // --- Creation flow (non-edit mode) ---
    let profileImageId = profileImage ? profileImage.id : null;
    let galleryImageIds = galleryImages.map((image) => image.id);

    const htmlTitle = `
            <span style="font-size: 10px; color: rgb(101, 101, 101);letter-spacing: .15em;">${productType}</span><br>
            <strong>${normalizedBrand}</strong><br>
            <div style="margin-top:10px; font-size:16px;">${title}</div><br>
        `;

    // Compose a detailed object for buildHtmlContent
    const finalDescription = buildHtmlContent({
      // Condition & Descriptions
      conditionValue: Number(conditionOptions[condition] || 0),
      conditionText: condition,
      customDescription,
      detailedDescription,
      // Product Info
      brand: normalizedBrand,
      productType,
          title,
      // Colors and Materials
      exteriorColor,
      interiorColor,
      exteriorMaterial,
      interiorMaterial,
      hardwareColor,
      // Included Items
      includedItems,
      // IDs and Location
      designerId,
      entrupyId,
      location,
      sortlyId,
      // Dimensions
      length,
      height,
      depth,
      isFootwear: isFootwearSelected,
      // Layaway
      layaway: isLayaway,
      layawayPlan: isLayaway ? layawayOption : null,
      layawayDetails: {
        fullPrice: price,
        salePrice,
        layawayOption,
      },
      // Pricing
      price,
      salePrice,
      msrpPrice,
      // Extra info for HTML sections
      productInfo: {
        colorExt: exteriorColor,
        colorInt: interiorColor,
        materialExt: exteriorMaterial,
        materialInt: interiorMaterial,
        includes: includedItems,
        hardware: hardwareColor,
        designerId,
        entrupyId,
        location,
        dimensions: {
          length,
          height,
          depth,
        },
      },
      // For toggles and shortcodes
      richDescription: detailedDescription,
      specificDescription: customDescription,
      // For table, toggles, and extra HTML
      toggles: [
        {
          title: "Descriere detaliată",
          content: detailedDescription,
        },
        {
          title: "Descriere stare",
          content: customDescription,
        },
        {
          title: "Informații suplimentare",
          content: `
                        <div>
                            <strong>Material exterior:</strong> ${exteriorMaterial}<br/>
                            <strong>Material interior:</strong> ${interiorMaterial}<br/>
                            <strong>Culoare exterior:</strong> ${exteriorColor}<br/>
                            <strong>Culoare interior:</strong> ${interiorColor}<br/>
                            <strong>Culoare hardware:</strong> ${hardwareColor}<br/>
                            <strong>Dimensiuni (cm):</strong> ${length} x ${height} x ${depth}<br/>
                            <strong>Vine însoțit de:</strong> ${includedItems && includedItems.length > 0 ? includedItems.join(", ") : "—"}<br/>
                            <strong>Designer ID:</strong> ${designerId}<br/>
                            <strong>Entrupy ID:</strong> ${entrupyId}<br/>
                            <strong>Sortly ID:</strong> ${sortlyId}<br/>
                            <strong>Locație:</strong> ${location}
                        </div>
                    `,
        },
      ],
      layawayTable: isLayaway
        ? {
            option: layawayOption,
            price,
            salePrice,
          }
        : null,
    });

    const publishDateTime =
      isProductScheduled && scheduledDate && scheduledTime
        ? dayjs(scheduledDate)
            .hour(dayjs(scheduledTime).hour())
            .minute(dayjs(scheduledTime).minute())
            .second(0)
            .format("YYYY-MM-DDTHH:mm:ss")
        : null;

    const primaryCategoryName =
      selectedCategories && selectedCategories.length > 0
        ? selectedCategories[0].name
        : "";
    const focusTitle =
      `${normalizedBrand ? normalizedBrand : ""} ${title ? title : ""}`.trim();
    const yoastDescription =
      `Descoperă ${normalizedBrand || ""} ${title || ""} pre-owned. Descoperă o selecție diversificată de stiluri de ${primaryCategoryName || "categorie"} ${normalizedBrand || ""}`
        .replace(/\s+/g, " ")
        .trim();

    const productData = {
      name: htmlTitle,
      regular_price: price,
      sale_price: salePrice,
      msrp_price: msrpPrice,
      description: finalDescription,
      status: isProductScheduled ? "future" : status,
      date_created: publishDateTime,
      categories: selectedCategories.map((category) => ({ id: category.id })),
      date_on_sale_from:
        isSaleScheduled && dateFrom
          ? dayjs(dateFrom).format("YYYY-MM-DD")
          : null,
      date_on_sale_to:
        isSaleScheduled && dateTo ? dayjs(dateTo).format("YYYY-MM-DD") : null,
      images: [
        ...(profileImageId ? [{ id: profileImageId }] : []),
        ...galleryImageIds.map((id) => ({ id })),
      ],
      stock_quantity: 1,
      manage_stock: true,
      sku: sku,
      tags: [{ name: normalizedBrand }],
      attributes: (() => {
        const base = [
          { id: 9, name: "Condiție", options: [condition] },
          { id: 10, name: "Designeri", options: [normalizedBrand] },
          { id: 15, name: "Badge", options: [productType] },
          { id: 2, name: "Culoare", options: [exteriorColor] },
          {
            id: 11,
            name: "Categorie",
            options: selectedCategories.map((c) => c.name),
          },
          { id: 24, name: "DesignerID", options: [designerId] },
          { id: 23, name: "Insotit", options: includedItems },
          { id: 17, name: "Pentru", options: [pentru] },
        ];
        // Exclude Entrupy for footwear; add size attributes
        if (!isFootwearSelected && entrupyId) {
          base.splice(6, 0, { id: 22, name: "Entrupy", options: [entrupyId] });
        }
        if (isFootwearSelected) {
          if (length)
            base.push({
              id: 8,
              name: "Marime incaltaminte",
              options: [String(length)],
            });
          if (height)
            base.push({ name: "Centimetri", options: [String(height)] });
        }
        return base;
      })(),
      meta_data: [
        { key: "msrp_price", value: msrpPrice },
        { key: "_yoast_wpseo_focuskw", value: focusTitle },
        { key: "_yoast_wpseo_title", value: focusTitle },
        { key: "_yoast_wpseo_metadesc", value: yoastDescription },
        { key: "_yoast_wpseo_opengraph-title", value: focusTitle },
        { key: "_yoast_wpseo_opengraph-description", value: yoastDescription },
        { key: "_yoast_wpseo_twitter-title", value: focusTitle },
        { key: "_yoast_wpseo_twitter-description", value: yoastDescription },
      ],
    };

    console.log(
      "Product Data before creation:",
      JSON.stringify(productData, null, 2)
    );

    try {
      const productResponse = await axios.post(
        "https://server-9p4hx.kinsta.app/api/masterdata/woo/create-product",
        productData
      );

      console.log("Product Response:", productResponse.data);

      const productId = productResponse.data.id;

      if (isLayaway) {
        const selectedPrice = Number(salePrice || price) || 0;
        const resolvedPlan =
          layawayOption ||
          (selectedPrice > 0 && selectedPrice <= 2000
            ? "1 Rata Speciala"
            : "");
        if (resolvedPlan) {
          await setSumoPaymentPlans(productId, resolvedPlan);
        }
      }

      resetForm();
      alert("Product created successfully!");
    } catch (error) {
      console.error(
        "Error creating product:",
        error.response ? error.response.data : error.message
      );
      alert("Failed to create product.");
    }
  };

  const setSumoPaymentPlans = async (productId, layawayOption) => {
    const sumoMetaData = [
      { key: "_sumo_pp_enable_sumopaymentplans", value: "yes" },
      { key: "_sumo_pp_payment_type", value: "payment-plans" },
      { key: "_sumo_pp_available_dates_from", value: "" },
      { key: "_sumo_pp_available_dates_to", value: "" },
      { key: "_sumo_pp_apply_global_settings", value: "" },
      { key: "_sumo_pp_force_deposit", value: "" },
      { key: "_sumo_pp_default_selected_type", value: "payment-plans" },
      { key: "_sumo_pp_deposit_type", value: "pre-defined" },
      { key: "_sumo_pp_deposit_price_type", value: "fixed-price" },
      { key: "_sumo_pp_pay_balance_type", value: "after" },
      { key: "_sumo_pp_pay_balance_after", value: "" },
      { key: "_sumo_pp_pay_balance_before", value: "" },
      { key: "_sumo_pp_pay_balance_before_booked_date", value: "" },
      { key: "_sumo_pp_set_expired_deposit_payment_as", value: "normal" },
      { key: "_sumo_pp_fixed_deposit_price", value: "" },
      { key: "_sumo_pp_fixed_deposit_percent", value: "" },
      {
        key: "_sumo_pp_user_defined_deposit_type",
        value: "percent-of-product-price",
      },
      { key: "_sumo_pp_min_user_defined_deposit_price", value: "" },
      { key: "_sumo_pp_max_user_defined_deposit_price", value: "" },
      { key: "_sumo_pp_min_deposit", value: "" },
      { key: "_sumo_pp_max_deposit", value: "" },
    ];

    let plans = [];
    switch (layawayOption) {
      case "1 Rata":
        plans = ["10956"];
        break;
      case "2 Rate":
        plans = ["10956", "10957"];
        break;
      case "3 Rate":
        plans = ["10956", "10957", "10969"];
        break;
      case "1 Rata Speciala":
        plans = ["106724"];
        break;
      default:
        break;
    }

    sumoMetaData.push({
      key: "_sumo_pp_selected_plans",
      value: { col_1: plans },
    });

    try {
      await axios.put(
        `https://www.luxuraelite.ro/wp-json/wc/v3/products/${productId}`,
        {
          meta_data: sumoMetaData,
        },
        {
          headers: {
            Authorization: "Basic " + btoa(`${consumerKey}:${consumerSecret}`),
            "Content-Type": "application/json",
          },
        }
      );

      console.log("SUMO Payment Plans set successfully");
    } catch (error) {
      console.error(
        "Error setting SUMO Payment Plans:",
        error.response ? error.response.data : error.message
      );
      alert("Failed to set SUMO Payment Plans.");
    }
  };

  const handleFilter = async () => {
    const brandFilter = brand;
    const categoryFilter = selectedCategories.map((category) => category.name);

    try {
      const response = await axios.get(
        "https://server-9p4hx.kinsta.app/api/masterdata/filter-products",
        {
          params: {
            brand: brandFilter,
            category: categoryFilter.join(","),
          },
        }
      );
      // Verificăm dacă răspunsul conține un array valid înainte de a-l seta
      if (Array.isArray(response.data)) {
        setFilteredProducts(response.data);
      } else {
        console.error("Filtered products is not an array");
      }
    } catch (error) {
      console.error("Error fetching filtered products:", error);
    }
  };

  const handleProductSelect = (sku) => {
    setSelectedProductIds((prevIds) => {
      if (prevIds.includes(sku)) {
        return prevIds.filter((id) => id !== sku);
      } else {
        return [...prevIds, sku];
      }
    });
  };

  // Funcția pentru a construi opțiunile de categorii și subcategorii
  const renderCategoryOptions = (categories, level = 0) => {
    if (!Array.isArray(categories)) {
      return [];
    }

    return categories.flatMap((category) => [
      {
        ...category,
        label: `${"—".repeat(level)} ${category.name}`,
        value: category.id,
        key: `${category.id}-${level}-${category.name}`,
      },
      // Recursiv pentru subcategorii
      ...renderCategoryOptions(category.children || [], level + 1),
    ]);
  };

  const flatCategories = renderCategoryOptions(localWooCategories);

  // Limit selectable categories to the top-level children under "Luxura Boutique"
  const findCategoryByName = (nodes, targetName) => {
    const target = normalize(targetName);
    const stack = Array.isArray(nodes) ? [...nodes] : [];
    while (stack.length) {
      const node = stack.shift();
      if (normalize(node.name) === target) return node;
      if (node.children && node.children.length) stack.push(...node.children);
    }
    return null;
  };

  const luxuraBoutiqueNode = findCategoryByName(
    localWooCategories,
    "Luxura Boutique"
  );
  const flatBoutiqueParents =
    luxuraBoutiqueNode && Array.isArray(luxuraBoutiqueNode.children)
      ? luxuraBoutiqueNode.children.map((c) => ({
          ...c,
          label: c.name,
          value: c.id,
          key: `${c.id}-luxura-boutique-parent`,
        }))
      : [];

  const resetForm = () => {
    setTitle("");
    setPrice("");
    setSalePrice("");
    setMsrpPrice("");
    setDescription("");
    setStatus("draft");
    setSelectedCategories([]);
    setProductType("HARD TO FIND");
    setBrand("HERMÈS");
    setCondition("Nou");
    setCustomDescription("");
    setIsSaleScheduled(false);
    setIsProductScheduled(false);
    setScheduledDate(null);
    setScheduledTime(null);
    setDateFrom(null);
    setDateTo(null);
    setProfileImage(null);
    setGalleryImages([]);
    setProgress(0);
    setSku("");
    setExteriorColor("Maro");
    setInteriorColor("Bordo");
    setExteriorMaterial("Monogram Canvas");
    setInteriorMaterial("Microfibra");
    setIncludedItems([]);
    setHardwareColor("Auriu");
    setDesignerId("M46197");
    setEntrupyId("DHGGCC8");
    setLocation("Exclusiv Online");
    setLength("");
    setHeight("");
    setDepth("");
    setDetailedDescription("");
    setSortlyId("");
    setLayawayOption("");
    setIsLayaway(false);
    setPentru("");
    setSelectedProductIds([]);
  };

  // Track active section for tips (IntersectionObserver)
  useEffect(() => {
    const ids = [
      "section-info",
      "section-pricing",
      "section-attributes",
      "section-details",
      "section-images",
      "section-publishing",
      "section-layaway",
    ];
    const els = ids
      .map((id) => ({ id, el: document.getElementById(id) }))
      .filter((x) => !!x.el);
    if (!els.length) return;
    const obs = new IntersectionObserver(
      (entries) => {
        const vis = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (vis[0]) {
          setActiveSection(vis[0].target.id);
        }
      },
      { rootMargin: "-20% 0px -60% 0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
    );
    els.forEach(({ el }) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          primary: { main: "#7c3aed" },
          secondary: { main: "#06b6d4" },
        },
        shape: { borderRadius: 12 },
        components: {
          MuiTextField: {
            defaultProps: {
              size: compact ? "small" : "medium",
              variant: "outlined",
            },
            styleOverrides: {
              root: { "& .MuiOutlinedInput-root": { borderRadius: 12 } },
            },
          },
          MuiSelect: {
            defaultProps: { variant: "outlined" },
            styleOverrides: { outlined: { borderRadius: 12 } },
          },
          MuiAutocomplete: {
            styleOverrides: {
              root: { "& .MuiOutlinedInput-root": { borderRadius: 12 } },
            },
          },
          MuiButton: {
            styleOverrides: {
              root: { borderRadius: 10, textTransform: "none" },
            },
          },
          MuiChip: { styleOverrides: { root: { borderRadius: 8 } } },
          MuiPaper: { styleOverrides: { rounded: { borderRadius: 16 } } },
        },
      }),
    [compact]
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <Box sx={{ p: 2, maxWidth: 1200, mx: "auto" }}>
          <Paper
            elevation={3}
            sx={{
              p: 2.5,
              mb: 2,
              borderRadius: 3,
              background: "linear-gradient(135deg, #7c3aed 0%, #06b6d4 100%)",
              color: "#fff",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={() => window.history.back()}
                  startIcon={<ArrowBack />}
                >
                  Înapoi
                </Button>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, letterSpacing: 0.2 }}
                >
                  {isEditMode ? "Edit Product" : "Create Product"}
                </Typography>
              </Stack>
              <FormControlLabel
                control={<Switch checked={true} onChange={() => {}} />}
                label=""
                sx={{ display: "none" }}
              />
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Spațiere
                </Typography>
                <FormControlLabel
                  control={
                    <Switch
                      color="default"
                      checked={compact}
                      onChange={(e) => setCompact(e.target.checked)}
                    />
                  }
                  label={
                    <Typography variant="body2" sx={{ opacity: 0.9 }}>
                      Compact
                    </Typography>
                  }
                  sx={{ mr: 0 }}
                />
              </Stack>
            </Stack>
          </Paper>

          <Grid container spacing={compact ? 2 : 3} alignItems="flex-start">
            <Grid item xs={12} md={8}>
              <Box id="section-info">
                <Box id="section-condition">
                  <Paper
                    sx={{
                      p: 3,
                      mb: 3,
                      borderRadius: 3,
                      background:
                        "linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, rgba(124,58,237,.35), rgba(6,182,212,.35)) border-box",
                      border: "1px solid transparent",
                    }}
                  >
                    <Typography variant="h6" gutterBottom>
                      <CategoryIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                      Informații produs
                    </Typography>
                    <Grid container spacing={2}>
                      {nextProductId && (
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Product ID"
                            value={nextProductId}
                            fullWidth
                            InputProps={{ readOnly: true }}
                            helperText="Generat automat"
                          />
                        </Grid>
                      )}
                      {sku && (
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="SKU"
                            value={sku}
                            fullWidth
                            InputProps={{ readOnly: true }}
                            helperText="Se propune automat după categorie"
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} sm={3}>
                        <FormControl
                          fullWidth
                          required
                          error={touched.productType && !!errors.productType}
                        >
                          <InputLabel>Badge</InputLabel>
                          <Select
                            value={productType}
                            onChange={(e) => setProductType(e.target.value)}
                            onBlur={() => onBlurValidate("productType")}
                            label="Badge"
                          >
                            {productTypes.map((type) => (
                              <MenuItem key={type} value={type}>
                                {type}
                              </MenuItem>
                            ))}
                          </Select>
                          {touched.productType && errors.productType && (
                            <FormHelperText>
                              {errors.productType}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <FormControl
                          fullWidth
                          required
                          error={touched.brand && !!errors.brand}
                        >
                          <InputLabel>Brand</InputLabel>
                          <Select
                            value={brand}
                            onChange={(e) => setBrand(e.target.value)}
                            onBlur={() => onBlurValidate("brand")}
                            label="Brand"
                          >
                            {brands.map((brand) => (
                              <MenuItem key={brand} value={brand}>
                                {brand}
                              </MenuItem>
                            ))}
                          </Select>
                          {touched.brand && errors.brand && (
                            <FormHelperText>{errors.brand}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          label="Model"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                          onBlur={() => onBlurValidate("title")}
                          fullWidth
                          placeholder="Ex: Neverfull MM Monogram"
                          required
                          error={touched.title && !!errors.title}
                          helperText={
                            (touched.title && errors.title) ||
                            "Denumirea comercială a produsului"
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl
                          fullWidth
                          required
                          error={touched.categories && !!errors.categories}
                        >
                          <Autocomplete
                            multiple
                            options={flatCategories}
                            getOptionLabel={(option) =>
                              option.label || option.name
                            }
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            value={selectedCategories}
                            onChange={(event, newValue) =>
                              setSelectedCategories(newValue)
                            }
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => (
                                <Chip
                                  key={option.id}
                                  label={option.name}
                                  {...getTagProps({ index })}
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                label="Categorii"
                                placeholder="Selectează categoriile"
                                onBlur={() => onBlurValidate("categories")}
                                error={
                                  touched.categories && !!errors.categories
                                }
                                helperText={
                                  (touched.categories && errors.categories) ||
                                  "Poți selecta una sau mai multe categorii"
                                }
                              />
                            )}
                          />
                          {touched.categories && errors.categories && (
                            <FormHelperText>{errors.categories}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Paper>
                </Box>
              </Box>

              <Box id="section-pricing">
                <Box id="section-images">
                  <Paper
                    sx={{
                      p: 3,
                      mb: 3,
                      borderRadius: 3,
                      background:
                        "linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, rgba(6,182,212,.35), rgba(124,58,237,.35)) border-box",
                      border: "1px solid transparent",
                    }}
                  >
                    <Typography variant="h6" gutterBottom>
                      <MonetizationOnIcon
                        sx={{ mr: 1, verticalAlign: "middle" }}
                      />{" "}
                      Pricing
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mt: 1,
                        mb: 2,
                      }}
                    >
                      <TextField
                        label="Preț"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        onBlur={() => onBlurValidate("price")}
                        fullWidth
                        sx={{ mr: 2 }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              RON
                            </InputAdornment>
                          ),
                        }}
                        helperText="Prețul de listă (RON)"
                        error={touched.price && !!errors.price}
                        required
                      />
                      <TextField
                        label="Preț la Reducere"
                        value={salePrice}
                        onChange={(e) => setSalePrice(e.target.value)}
                        fullWidth
                        sx={{ mr: 2 }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              RON
                            </InputAdornment>
                          ),
                        }}
                        helperText="Dacă este la promoție (RON)"
                      />
                      <TextField
                        label="Preț de Retail MSRP"
                        value={msrpPrice}
                        onChange={(e) => setMsrpPrice(e.target.value)}
                        fullWidth
                        sx={{ mr: 2 }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              RON
                            </InputAdornment>
                          ),
                        }}
                        helperText="Prețul recomandat de producător (opțional)"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isSaleScheduled}
                            onChange={(e) =>
                              setIsSaleScheduled(e.target.checked)
                            }
                          />
                        }
                        label="Schedule Sale"
                      />
                    </Box>
                    {isSaleScheduled && (
                      <Box
                        sx={{ display: "flex", alignItems: "center", mb: 2 }}
                      >
                        <DesktopDatePicker
                          label="De la"
                          inputFormat="DD/MM/YYYY"
                          value={dateFrom}
                          onChange={(newValue) => setDateFrom(newValue)}
                          renderInput={(params) => (
                            <TextField {...params} sx={{ mr: 2 }} />
                          )}
                        />
                        <DesktopDatePicker
                          label="Până la"
                          inputFormat="DD/MM/YYYY"
                          value={dateTo}
                          onChange={(newValue) => setDateTo(newValue)}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </Box>
                    )}
                  </Paper>
                </Box>
              </Box>

              <Box id="section-attributes">
                <Paper
                  sx={{
                    p: 3,
                    mb: 3,
                    borderRadius: 3,
                    background:
                      "linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, rgba(124,58,237,.35), rgba(6,182,212,.35)) border-box",
                    border: "1px solid transparent",
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    <InfoIcon sx={{ mr: 1, verticalAlign: "middle" }} />{" "}
                    Condition & Description
                  </Typography>
                  <Box
                    sx={{ display: "flex", alignItems: "center", mt: 1, mb: 2 }}
                  >
                    <FormControl
                      sx={{ mr: 2, flex: 1 }}
                      required
                      error={touched.condition && !!errors.condition}
                    >
                      <InputLabel>Condiție</InputLabel>
                      <Select
                        value={condition}
                        onChange={(e) => setCondition(e.target.value)}
                        onBlur={() => onBlurValidate("condition")}
                        label="Condiție"
                      >
                        {Object.keys(conditionOptions).map((cond) => (
                          <MenuItem key={cond} value={cond}>
                            {cond}
                          </MenuItem>
                        ))}
                      </Select>
                      {touched.condition && errors.condition && (
                        <FormHelperText>{errors.condition}</FormHelperText>
                      )}
                    </FormControl>
                  </Box>
                  <Stack spacing={1} sx={{ mb: 2 }}>
                    <Box>
                      <TextField
                        label="Descriere Condiție"
                        value={customDescription}
                        onChange={(e) => setCustomDescription(e.target.value)}
                        fullWidth
                        multiline
                        rows={4}
                        placeholder="Ex: Minime urme de purtare la colțuri, interior curat, hardware cu zgârieturi fine."
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="Reformulează cu AI"
                                edge="end"
                                color="primary"
                                disabled={
                                  rephraseLoading || !customDescription?.trim()
                                }
                                onClick={async () => {
                                  try {
                                    setWaveEffect(true);
                                    setTimeout(
                                      () => setWaveEffect(false),
                                      1000
                                    );
                                    setRephraseLoading(true);
                                    const prompt = `Scrie o descriere tehnică, profesională, concisă, în limba română, a stării unui articol de lux vândut ca pre-owned, bazată pe textul utilizatorului dintre marcajele ===. Normalizează redactarea (terminologie consistentă: colțuri, piele, material, hardware, interior, talpă), evită hiperbole, folosește propoziții clare și obiective, nu include emoji sau laude de marketing. Dacă e încălțăminte, include o propoziție separată privind starea tălpii. Respectă diacriticele. Include doar conținutul reformatat, fără alte explicații. === ${customDescription} ===`;
                                    const { data } = await axios.post(
                                      "https://server-9p4hx.kinsta.app/api/qc/openai-rephrase",
                                      { prompt }
                                    );
                                    if (data?.content)
                                      setCustomDescription(data.content.trim());
                                  } catch (err) {
                                    console.error(
                                      "Rephrase error",
                                      err?.response?.data || err?.message
                                    );
                                    alert(
                                      "Nu am reușit să reformulez descrierea. Încearcă din nou."
                                    );
                                  } finally {
                                    setRephraseLoading(false);
                                  }
                                }}
                                sx={{
                                  background: rephraseLoading
                                    ? "rgba(124,58,237,0.12)"
                                    : "rgba(124,58,237,0.08)",
                                  borderRadius: 2,
                                  ml: 1,
                                  transition: "background 0.2s",
                                  ...(rephraseLoading && {
                                    pointerEvents: "none",
                                    opacity: 0.7,
                                  }),
                                }}
                              >
                                {rephraseLoading ? (
                                  <CircularProgress size={18} />
                                ) : (
                                  <AutoFixHighIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        className={waveEffect ? "wave-effect" : ""}
                      />
                    </Box>
                  </Stack>
                </Paper>
              </Box>

              <Box id="section-details">
                <Paper
                  sx={{
                    p: 3,
                    mb: 3,
                    borderRadius: 3,
                    background:
                      "linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, rgba(6,182,212,.35), rgba(124,58,237,.35)) border-box",
                    border: "1px solid transparent",
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    <ImageIcon sx={{ mr: 1, verticalAlign: "middle" }} /> Images
                  </Typography>
                  <Box sx={{ display: "flex", mt: 1, mb: 2 }}>
                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        mr: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          paddingTop: "177.78%",
                          backgroundColor: "#f8fafc",
                          backgroundImage: profileImage
                            ? `url(${URL.createObjectURL(profileImage.file)})`
                            : "none",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          position: "relative",
                          border: "1px dashed #cbd5e1",
                          borderRadius: 2,
                          mb: 2,
                        }}
                      />
                      <Button variant="contained" component="label">
                        Upload Profile Image
                        <input
                          type="file"
                          hidden
                          onChange={(e) =>
                            handleImageChange("profile", e.target.files[0])
                          }
                        />
                      </Button>
                      {profileImage && (
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={() => setProfileImage(null)}
                          sx={{ mt: 1 }}
                        >
                          Delete
                        </Button>
                      )}
                    </Box>
                    <Box
                      sx={{ flex: 2, display: "flex", flexDirection: "column" }}
                    >
                      <Button
                        variant="contained"
                        component="label"
                        sx={{ mb: 2 }}
                      >
                        Upload Gallery Images
                        <input
                          type="file"
                          multiple
                          hidden
                          onChange={(e) =>
                            handleImageChange(
                              "gallery",
                              Array.from(e.target.files)
                            )
                          }
                        />
                      </Button>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
                        {galleryImages.map((image, index) => (
                          <Box
                            key={index}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              sx={{
                                width: 136,
                                height: 180,
                                backgroundColor: "#f8fafc",
                                backgroundImage: `url(${URL.createObjectURL(image.file)})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                position: "relative",
                                border: "1px solid #e5e7eb",
                                borderRadius: 2,
                              }}
                            />
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                mt: 1,
                              }}
                            >
                              <IconButton
                                size="small"
                                onClick={() => handleMoveImageLeft(index)}
                              >
                                <ArrowBack />
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={() => handleMoveImageRight(index)}
                              >
                                <ArrowForward />
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={() => handleDeleteImage(index)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </Box>
                  {uploadStatus && (
                    <Box
                      sx={{ display: "flex", justifyContent: "center", mt: 2 }}
                    >
                      <Typography variant="body2" color="textSecondary">
                        {uploadStatus}
                      </Typography>
                    </Box>
                  )}
                </Paper>
              </Box>

              <Box id="section-publishing">
                <Paper
                  sx={{
                    p: 3,
                    mb: 3,
                    borderRadius: 3,
                    background:
                      "linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, rgba(124,58,237,.35), rgba(6,182,212,.35)) border-box",
                    border: "1px solid transparent",
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    <LocalOfferIcon sx={{ mr: 1, verticalAlign: "middle" }} />{" "}
                    Attributes
                  </Typography>
                  <Box
                    sx={{ display: "flex", alignItems: "center", mt: 2, mb: 2 }}
                  >
                    <FormControl fullWidth sx={{ mr: 2 }}>
                      <InputLabel>Culoare Exterioară</InputLabel>
                      <Select
                        value={exteriorColor}
                        onChange={(e) => setExteriorColor(e.target.value)}
                        label="Culoarea Exterioară"
                      >
                        <MenuItem value="Maro">Maro</MenuItem>
                        <MenuItem value="Negru">Negru</MenuItem>
                        <MenuItem value="Alb">Alb</MenuItem>
                        <MenuItem value="Albastru">Albastru</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl fullWidth sx={{ mr: 2 }}>
                      <InputLabel>Culoare Interioară</InputLabel>
                      <Select
                        value={interiorColor}
                        onChange={(e) => setInteriorColor(e.target.value)}
                        label="Culoarea Interioară"
                      >
                        <MenuItem value="Bordo">Bordo</MenuItem>
                        <MenuItem value="Negru">Negru</MenuItem>
                        <MenuItem value="Alb">Alb</MenuItem>
                        <MenuItem value="Albastru">Albastru</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <FormControl fullWidth sx={{ mr: 2 }}>
                      <InputLabel>Material Exterior</InputLabel>
                      <Select
                        value={exteriorMaterial}
                        onChange={(e) => setExteriorMaterial(e.target.value)}
                        label="Material Exterior"
                      >
                        <MenuItem value="Monogram Canvas">
                          Monogram Canvas
                        </MenuItem>
                        <MenuItem value="Piele">Piele</MenuItem>
                        <MenuItem value="Bumbac">Bumbac</MenuItem>
                        <MenuItem value="Aur">Aur</MenuItem>
                        <MenuItem value="Argint">Argint</MenuItem>
                        <MenuItem value="Oțel">Oțel</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel>Material Interior</InputLabel>
                      <Select
                        value={interiorMaterial}
                        onChange={(e) => setInteriorMaterial(e.target.value)}
                        label="Material Interior"
                      >
                        <MenuItem value="Microfibra">Microfibra</MenuItem>
                        <MenuItem value="Piele">Piele</MenuItem>
                        <MenuItem value="Material">Material</MenuItem>
                        <MenuItem value="Microfibra">Microfibra</MenuItem>
                        <MenuItem value="Bumbac">Bumbac</MenuItem>
                        <MenuItem value="Canvas">Canvas</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <FormControl fullWidth sx={{ mr: 2 }}>
                      <InputLabel>Culoare Hardware</InputLabel>
                      <Select
                        value={hardwareColor}
                        onChange={(e) => setHardwareColor(e.target.value)}
                        label="Culoare Hardware"
                      >
                        <MenuItem value="Auriu">Auriu</MenuItem>
                        <MenuItem value="Argintiu">Argintiu</MenuItem>
                        <MenuItem value="Mat">Mat</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel>Pentru</InputLabel>
                      <Select
                        value={pentru}
                        onChange={(e) => setPentru(e.target.value)}
                        label="Pentru"
                      >
                        <MenuItem value="Femei">Femei</MenuItem>
                        <MenuItem value="Barbati">Barbati</MenuItem>
                        <MenuItem value="Copii">Copii</MenuItem>
                        <MenuItem value="Casa">Casa</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Vine Însoțit</InputLabel>
                    <Select
                      multiple
                      value={includedItems}
                      onChange={(e) => setIncludedItems(e.target.value)}
                      renderValue={(selected) => selected.join(", ")}
                      label="Vine Însoțit"
                    >
                      <MenuItem value="Dust bag">Dust bag</MenuItem>
                      <MenuItem value="Cutie">Cutie</MenuItem>
                      <MenuItem value="Certificat de conformitate">
                        Certificat de conformitate
                      </MenuItem>
                      <MenuItem value="Certificat Entrupy">
                        Certificat Entrupy
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Paper>
              </Box>

              <Box id="section-layaway">
                <Paper
                  sx={{
                    p: 3,
                    mb: 3,
                    borderRadius: 3,
                    background:
                      "linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, rgba(6,182,212,.35), rgba(124,58,237,.35)) border-box",
                    border: "1px solid transparent",
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    <DetailsIcon sx={{ mr: 1, verticalAlign: "middle" }} />{" "}
                    Detailed Information
                  </Typography>
                  <Box
                    sx={{ display: "flex", alignItems: "center", mt: 2, mb: 2 }}
                  >
                    <TextField
                      label="Designer ID"
                      value={designerId}
                      onChange={(e) => setDesignerId(e.target.value)}
                      fullWidth
                      sx={{ mr: 2 }}
                      placeholder="Ex: M46197"
                    />
                    {!isFootwearSelected && (
                      <TextField
                        label="Sortly ID"
                        value={sortlyId}
                        onChange={(e) => setSortlyId(e.target.value)}
                        fullWidth
                        placeholder="Ex: shelf-12/box-03"
                      />
                    )}
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    {!isFootwearSelected && (
                      <TextField
                        label="Entrupy ID"
                        value={entrupyId}
                        onChange={(e) => setEntrupyId(e.target.value)}
                        fullWidth
                        sx={{ mr: 2 }}
                        placeholder="Ex: DHGGCC8"
                      />
                    )}
                    <TextField
                      label="Jira ID"
                      value={location}
                      onChange={(e) => setLocation(e.target.value)}
                      fullWidth
                      placeholder="Ex: LEB-1234"
                    />
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    {isFootwearSelected ? (
                      <>
                        <FormControl fullWidth sx={{ mr: 2 }}>
                          <InputLabel>Mărime</InputLabel>
                          <Select
                            label="Mărime"
                            value={length}
                            onChange={(e) => setLength(e.target.value)}
                          >
                            {[
                              "36",
                              "36.5",
                              "37",
                              "37.5",
                              "38",
                              "38.5",
                              "39",
                              "39.5",
                              "40",
                              "40.5",
                              "41",
                              "41.5",
                              "42",
                              "42.5",
                              "43",
                              "43.5",
                              "44",
                              "44.5",
                              "45",
                              "45.5",
                              "46",
                            ].map((sz) => (
                              <MenuItem key={sz} value={sz}>
                                {sz}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <TextField
                          label="Centimetri (cm)"
                          type="number"
                          value={height}
                          onChange={(e) => setHeight(e.target.value)}
                          onBlur={() => {
                            const v = parseFloat(height);
                            setErrors((prev) => ({
                              ...prev,
                              centimetri:
                                Number.isFinite(v) && v > 0
                                  ? undefined
                                  : "Introduceți o valoare numerică validă",
                            }));
                          }}
                          error={!!errors.centimetri}
                          helperText={
                            errors.centimetri || "Lungimea tălpii în cm"
                          }
                          fullWidth
                          placeholder="Ex: 23.5"
                        />
                      </>
                    ) : (
                      <>
                        <TextField
                          label="Lungimea (cm)"
                          value={length}
                          onChange={(e) => setLength(e.target.value)}
                          fullWidth
                          sx={{ mr: 2 }}
                        />
                        <TextField
                          label="Inălțime (cm)"
                          value={height}
                          onChange={(e) => setHeight(e.target.value)}
                          fullWidth
                          sx={{ mr: 2 }}
                        />
                        <TextField
                          label="Adâncime (cm)"
                          value={depth}
                          onChange={(e) => setDepth(e.target.value)}
                          fullWidth
                        />
                      </>
                    )}
                  </Box>
                  <TextField
                    label="Descriere Detaliată"
                    value={detailedDescription}
                    onChange={(e) => setDetailedDescription(e.target.value)}
                    fullWidth
                    multiline
                    rows={4}
                    sx={{ mb: 2 }}
                    placeholder="Ex: Descriere bogată a produsului, materiale, compartimentare, ce include pachetul, orice detalii utile clientului."
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Generează descriere SEO cu AI"
                            edge="end"
                            color="primary"
                            disabled={rephraseDetailedLoading}
                            onClick={async () => {
                              try {
                                setWaveEffectDetailed(true);
                                setTimeout(
                                  () => setWaveEffectDetailed(false),
                                  1000
                                );
                                setRephraseDetailedLoading(true);
                                // Compose prompt based on available fields
                                let prompt = "";
                                if (
                                  brand?.trim() &&
                                  title?.trim() &&
                                  exteriorMaterial?.trim() &&
                                  interiorMaterial?.trim()
                                ) {
                                  prompt = `Analizează produsul ${brand} ${title} realizat din materiale: exterior ${exteriorMaterial}, interior ${interiorMaterial}.
Te rog să îmi scrii o descriere SEO, legată de istoria produsului și brandului, fără copyright infringement deoarece suntem o piață pre-owned.
Să fie inspirațională, maxim 3 paragrafe. Include și “Made in: …” (încearcă să deduci unde a fost făcut).
La final adaugă exact acest paragraf, nealterat:
"Acest articol este un produs pre-owned, autentic și verificat de experții Luxura Elite. Toate produsele noastre provin de la clienți sau furnizori verificați."`;
                                } else if (brand?.trim() && title?.trim()) {
                                  prompt = `Analizează produsul ${brand} ${title}.
Te rog să îmi scrii o descriere SEO, legată de istoria produsului și brandului, fără copyright infringement deoarece suntem o piață pre-owned.
Să fie inspirațională, maxim 3 paragrafe. Include și “Made in: …” (încearcă să deduci unde a fost făcut).
La final adaugă exact acest paragraf, nealterat:
"Acest articol este un produs pre-owned, autentic și verificat de experții Luxura Elite. Toate produsele noastre provin de la clienți sau furnizori verificați."`;
                                } else {
                                  alert(
                                    "Completează Brand și Model pentru generarea descrierii."
                                  );
                                  setWaveEffectDetailed(false);
                                  return;
                                }
                                const { data } = await axios.post(
                                  "https://server-9p4hx.kinsta.app/api/qc/openai-rephrase",
                                  { prompt }
                                );
                                if (data?.content)
                                  setDetailedDescription(data.content.trim());
                              } catch (err) {
                                console.error(
                                  "Rephrase detailed error",
                                  err?.response?.data || err?.message
                                );
                                alert(
                                  "Nu am reușit să generez descrierea detaliată. Încearcă din nou."
                                );
                              } finally {
                                setRephraseDetailedLoading(false);
                              }
                            }}
                            sx={{
                              background: rephraseDetailedLoading
                                ? "rgba(124,58,237,0.12)"
                                : "rgba(124,58,237,0.08)",
                              borderRadius: 2,
                              ml: 1,
                              transition: "background 0.2s",
                              ...(rephraseDetailedLoading && {
                                pointerEvents: "none",
                                opacity: 0.7,
                              }),
                            }}
                          >
                            {rephraseDetailedLoading ? (
                              <CircularProgress size={18} />
                            ) : (
                              <AutoFixHighIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    className={waveEffectDetailed ? "wave-effect" : ""}
                  />
                </Paper>
              </Box>
              <Paper
                sx={{
                  p: 3,
                  mb: 3,
                  borderRadius: 3,
                  background:
                    "linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, rgba(124,58,237,.35), rgba(6,182,212,.35)) border-box",
                  border: "1px solid transparent",
                }}
              >
                <Typography variant="h6" gutterBottom>
                  <ScheduleIcon sx={{ mr: 1, verticalAlign: "middle" }} />{" "}
                  Publishing
                </Typography>
                <Box
                  sx={{ display: "flex", alignItems: "center", mt: 2, mb: 2 }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={status === "publish"}
                        onChange={(e) =>
                          setStatus(e.target.checked ? "publish" : "draft")
                        }
                      />
                    }
                    label={status === "publish" ? "Published" : "Ciorna"}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isProductScheduled}
                        onChange={(e) =>
                          setIsProductScheduled(e.target.checked)
                        }
                      />
                    }
                    label="Programare"
                  />
                  <FormControl fullWidth sx={{ ml: 2 }}>
                    <InputLabel>Locație</InputLabel>
                    <Select
                      value={location}
                      onChange={(e) => setLocation(e.target.value)}
                      label="Locație"
                    >
                      <MenuItem value="Exclusiv Online">
                        Exclusiv Online
                      </MenuItem>
                      <MenuItem value="Luxura Boutique Timișoara">
                        Luxura Boutique Timișoara
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                {isProductScheduled && (
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <DesktopDatePicker
                      label="Data"
                      inputFormat="DD/MM/YYYY"
                      value={scheduledDate}
                      onChange={(newValue) => setScheduledDate(newValue)}
                      renderInput={(params) => (
                        <TextField {...params} sx={{ mr: 2 }} />
                      )}
                    />
                    <TimePicker
                      label="Ora"
                      value={scheduledTime}
                      onChange={(newValue) => setScheduledTime(newValue)}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Box>
                )}
              </Paper>
              <Paper
                sx={{
                  p: 3,
                  mb: 3,
                  borderRadius: 3,
                  background:
                    "linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, rgba(6,182,212,.35), rgba(124,58,237,.35)) border-box",
                  border: "1px solid transparent",
                }}
              >
                <Typography variant="h6" gutterBottom>
                  <StorageIcon sx={{ mr: 1, verticalAlign: "middle" }} />{" "}
                  Layaway
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isLayaway}
                        onChange={(e) => setIsLayaway(e.target.checked)}
                      />
                    }
                    label="Dorești produsul în LLP?"
                  />
                </Box>
                {isLayaway && (
                  <>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                      <InputLabel>LLP</InputLabel>
                      <Select
                        value={layawayOption}
                        onChange={(e) => setLayawayOption(e.target.value)}
                        label="LLP"
                      >
                        {(() => {
                          const specialItem = (
                            <MenuItem
                              key="1 Rata Speciala"
                              value="1 Rata Speciala"
                            >
                              1 Rata Speciala (50% avans)
                            </MenuItem>
                          );
                          const standardItems = [
                            <MenuItem key="1 Rata" value="1 Rata">
                              1 Rata
                            </MenuItem>,
                            <MenuItem key="2 Rate" value="2 Rate">
                              2 Rate
                            </MenuItem>,
                            <MenuItem key="3 Rate" value="3 Rate">
                              3 Rate
                            </MenuItem>,
                          ];
                          const numericPrice = Number(salePrice || price) || 0;
                          if (numericPrice > 0 && numericPrice <= 2000) {
                            return [specialItem, ...standardItems];
                          }
                          return [...standardItems, specialItem];
                        })()}
                      </Select>
                    </FormControl>
                  </>
                )}
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={{ position: "sticky", top: 88 }}>
                <Paper sx={{ p: 2.5, borderRadius: 3 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 700, mb: 1 }}
                  >
                    Tips pentru secțiune
                  </Typography>
                  <Box>
                    {(() => {
                      const tipsMap = {
                        "section-info": [
                          "Alege corect Brand + Badge pentru SEO.",
                          "Modelul ar trebui să fie clar (ex: “Neverfull MM”).",
                          "Adaugă cel puțin o categorie relevantă.",
                        ],
                        "section-pricing": [
                          "Prețul trebuie să fie > 0.",
                          "Setează “Preț la Reducere” doar dacă e activă promoția.",
                          "Folosește MSRP doar informativ.",
                        ],
                        "section-condition": [
                          "Alege condiția corectă ca să fie afișată corect pe site.",
                          "Descrie clar uzura/hardware/colțuri/interior.",
                        ],
                        "section-images": [
                          "Imaginea de profil trebuie să fie clară, frontală.",
                          "Păstrează ordinea în galerie (detalii, colțuri, interior).",
                        ],
                        "section-attributes": [
                          "Completează culori/materiale pentru filtre.",
                          "“Vine Însoțit” influențează încrederea clientului.",
                        ],
                        "section-details": [
                          "DesignerID/Entrupy/Sortly ajută la identificare.",
                          "Descrierea detaliată crește conversia.",
                        ],
                        "section-publishing": [
                          "Folosește Programare pentru lansări coordonate.",
                          "Setează locația potrivită (online/boutique).",
                        ],
                        "section-layaway": [
                          "Activează LLP doar dacă e solicitat.",
                          "Alege planul corect după preț.",
                        ],
                      };
                      const list =
                        tipsMap[activeSection] || tipsMap["section-info"];

                      return (
                        <ul style={{ paddingLeft: 18, margin: 0 }}>
                          {list.map((t, i) => (
                            <li
                              key={i}
                              style={{ marginBottom: 6, color: "#475569" }}
                            >
                              {t}
                            </li>
                          ))}
                        </ul>
                      );
                    })()}
                  </Box>
                </Paper>
                <Paper sx={{ p: 2, mt: 2, borderRadius: 3 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 700, mb: 1 }}
                  >
                    Navigare rapidă
                  </Typography>
                  <Stack spacing={1}>
                    {[
                      { id: "section-info", label: "Info" },
                      { id: "section-pricing", label: "Pricing" },
                      { id: "section-attributes", label: "Condition" },
                      { id: "section-details", label: "Images" },
                      { id: "section-publishing", label: "Attributes" },
                      { id: "section-images", label: "Details" },
                      { id: "section-condition", label: "Publishing" },
                      { id: "section-layaway", label: "Layaway" },
                    ].map((s) => (
                      <Button
                        key={s.id}
                        size="small"
                        color={(() => {
                          const priceNum = parseFloat(price);
                          const completed = {
                            "section-info":
                              !!productType &&
                              !!brand &&
                              !!(title && title.trim()) &&
                              selectedCategories?.length > 0,
                            "section-pricing":
                              Number.isFinite(priceNum) && priceNum > 0,
                            "section-attributes": !!condition,
                            "section-details":
                              !!profileImage || galleryImages?.length > 0,
                            "section-publishing": true,
                            "section-images":
                              !!exteriorColor &&
                              !!interiorColor &&
                              !!exteriorMaterial &&
                              !!interiorMaterial &&
                              !!hardwareColor,
                            "section-condition": true,
                            "section-layaway":
                              !isLayaway || (isLayaway && !!layawayOption),
                          }[s.id];
                          return completed ? "success" : "inherit";
                        })()}
                        startIcon={(() => {
                          const priceNum = parseFloat(price);
                          const completed = {
                            "section-info":
                              !!productType &&
                              !!brand &&
                              !!(title && title.trim()) &&
                              selectedCategories?.length > 0,
                            "section-pricing":
                              Number.isFinite(priceNum) && priceNum > 0,
                            "section-attributes": !!condition,
                            "section-details":
                              !!profileImage || galleryImages?.length > 0,
                            "section-publishing": true,
                            "section-images":
                              !!exteriorColor &&
                              !!interiorColor &&
                              !!exteriorMaterial &&
                              !!interiorMaterial &&
                              !!hardwareColor,
                            "section-condition": true,
                            "section-layaway":
                              !isLayaway || (isLayaway && !!layawayOption),
                          }[s.id];
                          return completed ? (
                            <CheckCircleOutlineIcon fontSize="small" />
                          ) : (
                            <RadioButtonUncheckedIcon fontSize="small" />
                          );
                        })()}
                        variant={
                          activeSection === s.id ? "contained" : "outlined"
                        }
                        onClick={() => {
                          const el = document.getElementById(s.id);
                          if (el)
                            el.scrollIntoView({
                              behavior: "smooth",
                              block: "start",
                            });
                        }}
                      >
                        {s.label}
                      </Button>
                    ))}
                  </Stack>
                </Paper>
              </Box>
            </Grid>
          </Grid>

          <Paper
            elevation={3}
            sx={{
              position: "sticky",
              bottom: 16,
              p: 2,
              borderRadius: 3,
              mt: 4,
              backgroundColor: "#ffffffcc",
              backdropFilter: "blur(4px)",
            }}
          >
            {progress > 0 && (
              <Box sx={{ width: "100%", mb: 1 }}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                >{`Uploading images: ${progress}%`}</Typography>
                <LinearProgress variant="determinate" value={progress} />
              </Box>
            )}
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button onClick={resetForm} color="inherit">
                Resetează
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleCreateProduct}
              >
                Creează Produs
              </Button>
            </Stack>
          </Paper>

          <Box sx={{ mt: 4 }}>
            <Button variant="contained" color="primary" onClick={handleFilter}>
              Cauta Produse asemanatoare
            </Button>

            <Box sx={{ mt: 2 }}>
              {filteredProducts.map((product) => (
                <Card
                  key={product.sku}
                  sx={{ display: "flex", alignItems: "center", mb: 2 }}
                >
                  <Checkbox
                    checked={selectedProductIds.includes(product.sku)}
                    onChange={() => handleProductSelect(product.sku)}
                  />
                  <CardMedia
                    component="img"
                    sx={{ width: 100 }}
                    image={product.df_image_link}
                    alt={product.name}
                  />
                  <CardContent>
                    <Typography variant="body1">{product.name}</Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
          </Box>
        </Box>
      </ThemeProvider>
    </LocalizationProvider>
  );
};

export default CreateProductWoo;
